import React from "react";
import Image from "../Image";

const QuesHeader = ({ logo, title }) => {
  return (
    <div
      style={{
        height: "75px",
        borderBottom: "1px solid black",
        // background: "black",
        // color: "white",
      }}
    >
      <div
        style={{
          width: "90%",
          margin: "0 auto",
          height: "75px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          letterSpacing: "0.1rem",
        }}
      >
        <h1>{title}</h1>
        <Image height={"65px"} src={logo} />
      </div>
    </div>
  );
};

export default QuesHeader;
